import styled from "styled-components"
import { Typography } from "../../typography"

export const DeprecatedTable = (props: {
  type?: "fullWidth" | "card"
  hideOverflow?: boolean
  children?: React.ReactNode
  className?: string
  "data-test-id"?: string
}) => {
  return (
    <DeprecatedTableWrapper $type={props.type} $hideOverflow={props.hideOverflow ?? false} className={props.className}>
      <InnerTable data-test-id={props["data-test-id"]} $type={props.type}>
        {props.children}
      </InnerTable>
    </DeprecatedTableWrapper>
  )
}

export const DeprecatedTableWrapper = styled.div<{ $type?: "fullWidth" | "card"; $hideOverflow: boolean }>`
  ${({ $hideOverflow }) => !$hideOverflow && "overflow-x: auto;"}

  ${({ $type, theme }) => {
    if ($type === "card") {
      return `
      border: 1px solid ${theme.colors.grey.$200};
      border-radius: 0.75rem;
      box-shadow: ${theme.shadows.light};
      `
    }

    return `
      border-bottom: 1px solid ${theme.colors.grey.$200};
      border-top: 1px solid ${theme.colors.grey.$200};
    `
  }}
`

const InnerTable = styled.table<{ $type?: "fullWidth" | "card" }>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  background-color: ${({ theme }) => theme.colors.white};
  overflow: auto;

  & th,
  & td {
    padding: 0 1rem;
    height: 3.5rem;
    white-space: nowrap;
    vertical-align: middle;
  }

  & tr {
    position: relative;
    transition: background-color 0.2s ease;

    &:last-child td {
      border-bottom: 0 !important;
    }
  }

  & td {
    position: relative;
  }

  & tr td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.$200};
  }

  ${({ $type }) => {
    if ($type === "card") {
      return `
      & th {
        &:first-child {
          padding-left: 1.5rem;
        }

        &:last-child {
          padding-right: 1.5rem;
        }
      }

      & td {
        &:first-child {
          padding-left: 1.5rem;
        }
        &:last-child {
          padding-right: 1.5rem;
        }
      }
      `
    }

    return `
      & th {
        &:first-child {
          padding-left: 3rem;
        }

        &:last-child {
          padding-right: 3rem;
        }
      }

      & td {
        &:first-child {
          padding-left: 3rem;
        }
        &:last-child {
          padding-right: 3rem;
        }
      }
      `
  }}
`

export const DeprecatedTHead = styled(Typography).attrs(() => ({
  as: "thead",
  $variant: "label-1",
}))`
  text-align: left;
  background: ${({ theme }) => theme.colors.grey.$100};
  color: ${({ theme }) => theme.colors.grey.$500};

  & th {
    height: 2.5rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.$200};
    text-transform: uppercase;
  }
`

export const DeprecatedTBody = styled(Typography).attrs(() => ({
  as: "tbody",
  $variant: "body-4-medium",
}))<{ $clickable?: boolean }>`
  color: ${({ theme }) => theme.colors.grey.$600};

  & td {
    cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  }

  & tr:hover {
    background-color: ${({ $clickable, theme }) => {
      return $clickable ? theme.colors.grey.$200 : "transparent"
    }};
  }
  & tr:active {
    background-color: ${({ $clickable, theme }) => {
      return $clickable ? theme.colors.grey.$300 : "transparent"
    }};
  }
`

export const DeprecatedTableSection = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`

export const DeprecatedTableSectionHeader = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 1rem 3rem;
  position: sticky;
  top: 0;
  left: 0;
`
